/* BEVANUP_CART_ROUTE_UNIFIER_V1 */
(() => {
  const isCartRoute = location.pathname.replace(/\/+$/, '') === '/cart';
  if (isCartRoute) {
    location.replace('/?open_cart=1');
    return;
  }
  if (new URLSearchParams(location.search).get('open_cart') !== '1') return;
  const openDrawer = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    const dialog = document.querySelector('#cart-drawer dialog');
    const drawer = document.querySelector('#cart-drawer');
    if (!trigger || !dialog || !drawer) return false;
    if (!dialog.open) {
      try { dialog.showModal(); } catch (_) { return false; }
      drawer.setAttribute('open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }
    if (!dialog.open) return false;
    history.replaceState(history.state, '', location.pathname + location.hash);
    return true;
  };
  let retries = 0;
  const waitForDrawer = () => {
    if (openDrawer() || retries++ >= 60) return;
    window.setTimeout(waitForDrawer, 80);
  };
  waitForDrawer();
})();